const Innovation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "var(--width-48)", height: "var(--height-48)" }}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M22 4C13.164 4 6 11.09 6 19.838C6 22.824 6.834 25.618 8.286 28M29 22V26M35 22V26M29 6V10M35 6V10M26 13H22M26 19H22M42 13H38M42 19H38M28 38L27.74 39.294C27.46 40.708 27.318 41.414 27 41.974C26.51 42.8371 25.7166 43.4872 24.774 43.798C24.164 44 23.44 44 22 44C20.56 44 19.836 44 19.226 43.8C18.2831 43.4887 17.4896 42.8379 17 41.974C16.682 41.414 16.54 40.708 16.26 39.294L16 38M34 10H30C28.114 10 27.172 10 26.586 10.586C26 11.172 26 12.114 26 14V18C26 19.886 26 20.828 26.586 21.414C27.172 22 28.114 22 30 22H34C35.886 22 36.828 22 37.414 21.414C38 20.828 38 19.886 38 18V14C38 12.114 38 11.172 37.414 10.586C36.828 10 35.886 10 34 10ZM12.766 34.196C12.582 33.644 12.49 33.366 12.5 33.142C12.5113 32.9104 12.5895 32.687 12.7251 32.4989C12.8607 32.3108 13.0479 32.166 13.264 32.082C13.472 32 13.764 32 14.344 32H29.656C30.238 32 30.528 32 30.736 32.08C30.9524 32.1641 31.1398 32.3092 31.2755 32.4977C31.4111 32.6862 31.4891 32.91 31.5 33.142C31.51 33.366 31.418 33.642 31.234 34.196C30.894 35.218 30.724 35.73 30.462 36.144C29.914 37.0092 29.055 37.6313 28.062 37.882C27.586 38 27.05 38 25.976 38H18.024C16.95 38 16.412 38 15.938 37.88C14.9453 37.6298 14.0864 37.0085 13.538 36.144C13.276 35.73 13.106 35.218 12.766 34.196Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Innovation;
